// Official store links. Keep the package id in one place only.
export const PLAY_PACKAGE = "com.spotdrop.malta";
export const PLAY_URL = `https://play.google.com/store/apps/details?id=${PLAY_PACKAGE}`;
export const PLAY_BADGE_SRC = "/google-play-badge.png";
